/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MessageTypeIcon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import React from 'react'
import TaskAdded from './TaskAdded/index'
import TaskAssigned from './TaskAssigned/index'
import TaskMoved from './TaskMoved/index'



/** @type {import('Simple/types.js').View} */
export default function MessageTypeIcon({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/Content/Messages/All/Content/Message/MessageTypeIcon"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let messageIconValueData = fromData.useDataFormat({ viewPath,
context: 'message',
path: 'icon',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: messageIconValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TaskAdded'}>
<TaskAdded
  viewPath={`${viewPath}/TaskAdded`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TaskAssigned'}>
<TaskAssigned
  viewPath={`${viewPath}/TaskAssigned`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TaskMoved'}>
<TaskMoved
  viewPath={`${viewPath}/TaskMoved`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}